import { memo, useCallback } from "react";
import { SimpleSelect, SimpleSelectProps } from "../../SimpleSelect";
import { UNITS } from "../constants";
import { Locale } from "../types";
import { useCronFieldProps } from "./utils";

export type MonthsProps = Omit<SimpleSelectProps<number>, "onChange" | "options"> & {
  humanizeLabels?: boolean
  preferShortHumanLabels?: boolean
  locale: Locale
  onChange?: ((newValue: number[]) => void) | undefined
};

export const Months = memo((
  {
    locale,
    humanizeLabels,
    preferShortHumanLabels,
    ...props
  }: MonthsProps) => {
  const { options, onChange, isMulti } = useCronFieldProps(
    props.value,
    props.onChange,
    props.isMulti ?? false,
    UNITS.find(x => x.type === "months")!
  );

  const setOptionLabel = useCallback((v: number) => {
    if (!humanizeLabels) {
      return v.toString();
    }
    return preferShortHumanLabels ? locale?.altMonths?.[v - 1] : locale?.months?.[v - 1];
  }, [ humanizeLabels, preferShortHumanLabels, locale ]);

  return (
    <div>
      {locale.prefixMonths !== "" && (
        <span>{locale.prefixMonths}</span>
      )}

      <SimpleSelect
        placeholder={locale.emptyMonths}
        isClearable
        isSearchable
        {...props}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        setOptionLabel={setOptionLabel}
      />
    </div>
  );
});
